(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-select"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.variant-select').forEach((select) => {
    if (select.dataset.action !== 'submitForm') return

    select.addEventListener('change', (event) => {
      const form = event.target.closest('form')
      if (form) {
        form.requestSubmit()
      }
    })
  })
  } catch(e) { console.error(e); }
})();

})();
